import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class IndexService {
    constructor(
        private httpService: HttpService) { }

    // //获取中奖排行榜
    // //chen 2017-05-02
    // getLotteryWinRank() {
    //     return this.httpService.get(AppConfig.GetProdUrl() + '/Index/LotteryWinRank');
    // }

    //获取平台公告
    //chen 2017-05-03
    getAnnouncements() {
        var url = AppConfig.GetProdUrl() + '/Article/GetAnnouncements';
        return this.httpService.get(url);
    }

    // //获取公告详情
    // //chen 2017-05-11
    // getAnnouncementDetail(param) {
    //     var url = AppConfig.GetProdUrl() + '/Article/GetAnnouncement';
    //     return this.httpService.get(url, param);
    // }

    //获取最新开奖号码
    //TQQ 2017-05-12
    getLotteryOpenLatest() {
        var url = AppConfig.GetProdUrl() + '/Lottery/GetLotteryOpenLatest';
        return this.httpService.get(url);
    }

    //消费返现
    //TQQ 2017-05-17
    getConsumReturnCash() {
        var url = AppConfig.GetProdUrl() + '/Activity/EverydayRechargeSend';
        return this.httpService.get(url);
    }

    //判断用户是否领取返现红包
    //chen 2017-05-19
    getonsumRewards() {
        var url = AppConfig.GetProdUrl() + '/Activity/CheckConsumCash';
        return this.httpService.get(url);
    }

    //获取中奖名单
    //TQQ 2017-06-07
    getWinningData(params) {
        let url = AppConfig.GetProdUrl() + '/Report/GetWinningData';
        return this.httpService.get(url, params);
    }

    //新会员注册送礼
    //TQQ 2017-06-13
    firstRechargeSend() {
        var url = AppConfig.GetProdUrl() + '/Activity/FirstRechargeSend';
        return this.httpService.get(url);
    }

    //c8判断注册送18是否已经领取
    //TQQ 2017-06-15
    checkFirstRechargeSend() {
        var url = AppConfig.GetProdUrl() + '/Activity/CheckFirstRechargeSend';
        return this.httpService.get(url);
    }

    //获取APP下载二维码
    getAppQrcode() {
        var url = AppConfig.GetProdUrl() + '/Log/GetPhoneSettings';
        return this.httpService.post(url, "");
    }

    /**
     *判断vr是否开启
     *
     * @returns
     * @memberof IndexService
     */
    getAgStatus() {
        let url = AppConfig.GetProdUrl() + '/VedioRacing/VRisOpen';
        return this.httpService.post(url, "")
    }
    /**
     *
     *跳转VR
     * @param {number} [channelId=0]
     * @param {string} [departureUrl=""]
     * @returns
     * @memberof IndexService
     */
    logon(channelId = 0, departureUrl = "") {
        let url = AppConfig.GetProdUrl() + "/vedioracing/logon?channelId=" + channelId + "&departureUrl=" + departureUrl;
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/index.service.ts